export class PortalBase {
    constructor ( dataStore ) {
        this.dataStore = dataStore
    }

    // Returns a promise
    retrieveSection(sectionName) {
        return this.dataStore.retrieveSection(sectionName)
    }

    // Returns a promise
    storeSection(sectionName, section, order) {
        return this.dataStore.storeSection(sectionName, section, order)
    }

    // Returns a promise
    retrieveContent(companyId) {
        return this.dataStore.retrieveContent(companyId)
    }

    // Returns a promise
    storeContent(content) {
        return this.dataStore.storeContent(content)
    }

    
    // Returns a promise
    listSections() {
        return this.dataStore.listSections()
    }

    // Returns a promise
    retrieveFileUploadURL(fileName, options){
        return this.dataStore.retrieveFileUploadURL(fileName, options)
    }

    // Returns a promise
    retrieveFileDownloadURL(companyId, fileName, contentDisposition){
        return this.dataStore.retrieveFileDownloadURL(companyId, fileName, contentDisposition)
    }
    
    // Returns a promise
    listFileUpload(companyId){
        return this.dataStore.listFileUpload(companyId)
    }

    // Returns a promise
    removeFileUploadFile(fileName){
        return this.dataStore.removeFileUploadFile(fileName)
    }

    // Returns a promise
    retrieveMessages(companyId) {
        return this.dataStore.retrieveMessages(companyId)
    }

    // Returns a promise
    retrieveMessagesAsSOF(companyId) {
        return this.dataStore.retrieveMessagesAsSOF(companyId)
    }

    // Returns a promise
    retrieveRecentMessagesAsSOF() {
        return this.dataStore.retrieveRecentMessagesAsSOF()
    }

    // Returns a promise
    sendMessage(companyId, message) {
        return this.dataStore.sendMessage(companyId, message)
    }

    // Returns a promise
    sendMessageAsSOF(companyId, message) {
        return this.dataStore.sendMessageAsSOF(companyId, message)
    }

    search(queryString, size, from) {
        return this.dataStore.search(queryString, size, from)
    }

  // Returns a promise
    storeInterest(interestCriteria) {
        return this.dataStore.storeInterest(interestCriteria)
    }
        
    // Returns a promise
    retrieveInterest() {
        return this.dataStore.retrieveInterest()
    }
      
}

export default PortalBase